import qs from "qs";
import { ITicklerType } from "../../types/Tickler";
import authAxios, { authHeader } from "../data";

const fetchAll = async (req: any) => {
  const response = await authAxios.get("/api/TicklerTypes", {
    params: req,
    paramsSerializer: (params) => qs.stringify(params),
    headers: authHeader(),
  });

  return response.data;
};

const fetchNames = async () => {
  const response = await authAxios.get("/api/TicklerTypes/Names", {
    headers: authHeader(),
  });

  return response.data;
};

const fetchCount = async (req: any) => {
  const response = await authAxios.get("/api/TicklerTypes/Count", {
    headers: authHeader(),
  });

  return response.data;
};

const fetch = async (id: string) => {
  const response = await authAxios.get("/api/TicklerTypes/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const deleteTicklersType = async (id: string) => {
  const response = await authAxios.delete("/api/TicklerTypes/" + id, {
    headers: authHeader(),
  });

  return response.data;
};

const createTicklersType = async (req: ITicklerType) => {
  const response = await authAxios.post("/api/TicklerTypes", req, {
    headers: authHeader(),
  });

  return response.data;
};

const editTicklersType = async (req: ITicklerType, id: string) => {
  const response = await authAxios.put("/api/TicklerTypes/" + id, req, {
    headers: authHeader(),
  });

  return response.data;
};

const TicklersTypeService = {
  fetchAll,
  fetchNames,
  fetchCount,
  fetch,
  deleteTicklersType,
  createTicklersType,
  editTicklersType,
};

export default TicklersTypeService;
